import "./Common.scss";
import CardTitle from "./CardTitle";

const Card = ({
                children,
                id,
                color,
                padding,
                ifCond = true,
                title = null,
                titleActions = null,
                style = null,
                className
              }) => {
  if (!ifCond) {
    return null;
  }

  const classNames = [];

  if (color) {
    classNames.push("cust-color-" + color + "-border-left");
  }

  if (padding) {
    classNames.push("padding");
  }

  if (className) {
    classNames.push(className);
  }

  return (
    <>
      {title && <CardTitle title={title}>{titleActions}</CardTitle>}

      <div id={id} className="card app-card" style={style}>
        <div id={id ? id + "-content" : null} className={classNames.join(" ")}>
          {children}
        </div>
      </div>
    </>
  );
};

export default Card;
